import {
  getPortList,
  getAvailableLines,
  getVesselSchedule,
  sendRequestQuota
} from '@/api/vessel-schedule.api'
  
export const FETCH_PORTLIST = 'FETCH_PORTLIST'
export const FETCH_PORTLIST_LOADING = 'FETCH_PORTLIST_LOADING'
export const FETCH_PORTLIST_DONE = 'FETCH_PORTLIST_DONE'
export const FETCH_PORTLIST_ERROR = 'FETCH_PORTLIST_ERROR'

export const FETCH_AVAILABLE_LINES = 'FETCH_AVAILABLE_LINES'
export const FETCH_AVAILABLE_LINES_LOADING = 'FETCH_AVAILABLE_LINES_LOADING'
export const FETCH_AVAILABLE_LINES_DONE = 'FETCH_AVAILABLE_LINES_DONE'
export const FETCH_AVAILABLE_LINES_ERROR = 'FETCH_AVAILABLE_LINES_ERROR'

export const FETCH_VESSELSCHEDULE = 'FETCH_VESSELSCHEDULE'
export const FETCH_VESSELSCHEDULE_LOADING = 'FETCH_VESSELSCHEDULE_LOADING'
export const FETCH_VESSELSCHEDULE_DONE = 'FETCH_VESSELSCHEDULE_DONE'
export const FETCH_VESSELSCHEDULE_ERROR = 'FETCH_VESSELSCHEDULE_ERROR'

export const SEND_REQ_QUOTA = 'SEND_REQ_QUOTA'
export const SEND_REQ_QUOTA_LOADING = 'SEND_REQ_QUOTA_LOADING'
export const SEND_REQ_QUOTA_DONE = 'SEND_REQ_QUOTA_DONE'
export const SEND_REQ_QUOTA_ERROR = 'SEND_REQ_QUOTA_ERROR'

export default {
  [FETCH_PORTLIST] (context, payload) {
    context.commit(FETCH_PORTLIST_LOADING)
    return getPortList(payload)
      .then((response) => {
        context.commit(FETCH_PORTLIST_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_PORTLIST_ERROR, error)
      })
  },
  [FETCH_AVAILABLE_LINES] (context, payload) {
    context.commit(FETCH_AVAILABLE_LINES_LOADING)
    return getAvailableLines(payload)
      .then((response) => {
        context.commit(FETCH_AVAILABLE_LINES_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_AVAILABLE_LINES_ERROR, error)
      })
  },
  [FETCH_VESSELSCHEDULE] (context, payload) {
    context.commit(FETCH_VESSELSCHEDULE_LOADING)
    return getVesselSchedule(payload)
      .then((response) => {
        context.commit(FETCH_VESSELSCHEDULE_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_VESSELSCHEDULE_ERROR, error)
      })
  },
  [SEND_REQ_QUOTA] (context, payload) {
    context.commit(SEND_REQ_QUOTA_LOADING)
    return sendRequestQuota()
      .then((response) => {
        context.commit(SEND_REQ_QUOTA_DONE, response)
      })
      .catch((error) => {
        context.commit(SEND_REQ_QUOTA_ERROR, error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/vessel-schedule/actions.js